import React, { useContext } from 'react';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { MobileBottomNav } from './MobileBottomNav';
import { UserContext } from '../../context/UserContext';
interface LayoutProps {
  children: React.ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  const {
    userRole
  } = useContext(UserContext);
  return <div className="flex h-screen bg-gray-50" data-id="element-706">
      <Sidebar data-id="element-707" />
      <div className="flex-1 flex flex-col overflow-hidden" data-id="element-708">
        <Header data-id="element-709" />
        <main className="flex-1 overflow-x-hidden overflow-y-auto bg-gray-100 p-4" data-id="element-710">
          <div className="container mx-auto" data-id="element-711">{children}</div>
        </main>
      </div>
      {userRole === 'employee' && <MobileBottomNav data-id="element-712" />}
    </div>;
}